export { loadTranslations } from './load-translations';
